export const ADD_BUN_TO_CONSTRUCTOR: 'ADD_BUN_TO_CONSTRUCTOR' = 'ADD_BUN_TO_CONSTRUCTOR';

export const ADD_INGREDIENT_TO_CONSTRUCTOR: 'ADD_INGREDIENT_TO_CONSTRUCTOR' = 'ADD_INGREDIENT_TO_CONSTRUCTOR';
export const DELETE_INGREDIENT_FROM_CONSTRUCTOR: 'DELETE_INGREDIENT_FROM_CONSTRUCTOR' = 'DELETE_INGREDIENT_FROM_CONSTRUCTOR';
export const REORDER_INGREDIENTS_IN_CONSTRUCTOR: 'REORDER_INGREDIENTS_IN_CONSTRUCTOR' = 'REORDER_INGREDIENTS_IN_CONSTRUCTOR';

export const RESET_INGREDIENTS_IN_CONSTRUCTOR: 'RESET_INGREDIENTS_IN_CONSTRUCTOR' = 'RESET_INGREDIENTS_IN_CONSTRUCTOR';